import oem from "../assets/images/oem.jpeg";
import odm from "../assets/images/odm.jpeg";
import whiteLabel from "../assets/images/white-label.jpeg";

export default function Services() {
    const services = [
        {title:"OEM (Original Equipment Manufacturing)", desc:"Manufacturing products based on the customer's design and brand specifications.", img:oem, position:"img-left"},
        {title:"ODM (Original Design Manufacturing)", desc:"Providing product design and development services in addition to manufacturing. Clients can choose from existing product designs or request customization.", img:odm, position:"img-right"},
        {title:"White Labelling", desc:"Manufacturing generic products that are rebranded and sold under the customer’s company brand.", img:whiteLabel, position:"img-center"},
    ];

    return (
        <section id="services" className="py-5">
            <div className="container">
                <h2 className="section-title">Our Services</h2>
                <div className="row">
                    {services.map((s,i)=>(
                        <div key={i} className="col-md-4 my-3">
                            <div className="card p-3 text-center service-card h-100">
                                <img
                                    src={s.img}
                                    alt={s.title}
                                    className={s.position} // apply position class
                                />
                                <h5>{s.title}</h5>
                                <p>{s.desc}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
